/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import Compare from "./components/Compare";
import VehicleBox from "./components/VehicleBox";
import Table from "./components/Table";
import Basic from "assets/basic.svg";
import { Grid } from "@mui/material";
import { useIsInViewport } from "utils";
import Box from "ReusableComponents/Box";

const CompareVehicles = ({
  trucks,
  getRef,
  products,
  icons,
  small,
  OBJ,
  medium,
}) => {
  const containerRef = useRef(null);
  const [obj] = useState(OBJ);

  const isViewPort = useIsInViewport(containerRef);

  useEffect(() => {
    if (icons?.length) {
      icons?.map((item) => {
        obj["DV"][item?.attributes?.heading]["icon"] =
          item.attributes?.media?.data?.attributes?.url;
        obj["DV"][item?.attributes?.heading]["alt"] =
          item.attributes?.media?.data?.attributes?.alternativeText;
        obj["PV"][item?.attributes?.heading]["icon"] =
          item.attributes?.media?.data?.attributes?.url;
        obj["PV"][item?.attributes?.heading]["alt"] =
          item.attributes?.media?.data?.attributes?.alternativeText;
        obj["HD"][item?.attributes?.heading]["icon"] =
          item.attributes?.media?.data?.attributes?.url;
        obj["HD"][item?.attributes?.heading]["alt"] =
          item.attributes?.media?.data?.attributes?.alternativeText;
      });
    }
  }, [icons]);

  getRef(isViewPort);

  return (
    <Grid
      container
      spacing={2}
      sx={{ padding: small ? "40px" : "80px" }}
      ref={containerRef}
      id="specifications"
    >
      <Grid item xs={12} md={3}>
        <Compare getRef={getRef} small={small} medium={medium} />
      </Grid>

      <Grid item xs={12} md={9}>
        <Box
          display="flex"
          justifyContent="space-evenly"
          flexDirection={"row"}
          style={{ gap: "15px" }}
        >
          {products?.map((item, i) => {
            if (item?.attributes?.order <= 2)
              return (
                <VehicleBox
                  name={item?.attributes?.short_name}
                  img={item?.attributes?.main_img?.data?.attributes?.url}
                  alt={
                    item?.attributes?.main_img?.data?.attributes
                      ?.alternativeText
                  }
                  style={{ marginRight: 20 }}
                  key={item.id}
                  small={small}
                />
              );
          })}
        </Box>
      </Grid>

      {Object.keys(obj?.DV)?.map((item) => (
        <Grid item xs={12} key={item}>
          <Table
            OBJ={obj}
            trucks={trucks}
            type={item}
            Icon={Basic}
            keys={Object.keys(obj.DV[item])}
            icons={icons}
            small={small}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default CompareVehicles;
